import { isFeatureEnabled } from 'owa-feature-flags';
import { HeaderCharmType, toggleCharm } from 'owa-header-store';

// Toggle Time Panel based on Suite Header variant
export function toggleTimePanel() {
    if (isFeatureEnabled('fwk-o365shellheader')) {
        (window as any).O365Shell.FlexPane.OpenFlexPaneForProvider('OwaTimePanel');
    } else {
        toggleCharm(HeaderCharmType.TimePanelCharm);
    }
}
